export default __webpack_public_path__ + "static/media/logoBlack.c6f6b958.png";